"use strict";

angular.module('PatientApp').controller('EstimateDetailsCtrl', function ($q, $scope, $rootScope, $state, $interval, Compass, $filter, EstimatesService, VueEventTransmitter, VuexStore) {
  $rootScope.newContent = true;
  var _id = $state.params.estimateId;

  if (!_id) {
    $state.go('app.default');
  }

  VuexStore.commit('setShowLoading', true);

  $scope.getEstimate = function () {
    EstimatesService.getAccountEstimate(_id).then(function (resp) {
      VuexStore.commit('setCurrentEstimate', resp);
      $scope.estimate = resp;
      $scope.provider = resp.providerDetails;
      $scope.insuranceCoverage = resp.serviceAmount != null ? resp.serviceAmount - resp.estimatedAmount : 0;
      $scope.services = resp.services;
      VuexStore.commit('setShowLoading', false);
      VuexStore.dispatch('getProviderById', $scope.estimate.providerDetails.id).then(function (provider) {
        $scope.provider = provider;
        $scope.messageProviderData = {
          estimateId: _id,
          reason: 11
        };
      });
    }).catch(function () {
      Compass.capture.failure('estimate', 'id', '');
      $state.go('app.default');
    });
  };

  $scope.messageProvider = function () {
    VueEventTransmitter.$emit('message:compose', $scope.messageProviderData);
  };

  $scope.getEstimate(); // Only use when testing SubAccountsDetailsServices

  /*$scope.services = [
      { name: 'Knee Arthroscopy w/ Meniscus Surgery', cost: 0.00 },
      { name: 'Laboratory'},
      { name: 'Room & Board', cost: 1000 }
  ];*/
});